export default "__VITE_ASSET__G$GV49MZ__"